"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _modalActions = require("../../../../../redux/actions/modalActions");
var _DisableModalComponent = _interopRequireDefault(require("./DisableModalComponent"));
var _modalDecorator = _interopRequireDefault(require("../../../../../hocs/modalDecorator"));
var _interestAccountActions = require("../../../../../redux/actions/interestAccountActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    disable: function disable() {
      return dispatch((0, _interestAccountActions.disableInterestAccountRequest)());
    }
  };
};
var container = (0, _reactRedux.connect)(null, mapDispatchToProps)(_DisableModalComponent["default"]);
var _default = exports["default"] = (0, _modalDecorator["default"])({
  name: _modalActions.MODAL_TYPES.INTEREST_DISABLE
})(container);